<template>
  <div class="mb-6" :class="{inactive: !active}">
    <!-- Wait for client before rendering -->
    <a
       v-if="call.client"
       :title="`Ga naar het gesprek met ${call.client.title} ${call.client.name}`"
       @click="gotoCall(call.id)" class="index-card">

      <!-- Clickable row element -->
      <div class="index-card-content has-text-dark">

        <!-- Profile pic -->
        <div class="index-card-thumbnail icon">
          <AvatarCircle :src="call.client.avatar"></AvatarCircle>
        </div>

        <!-- Info -->
        <div class="index-card-info">

          <!-- Top tow -->
          <div class="index-card-title">
            {{call.client.name}}
          </div>

          <hr>

          <!-- Bottom row -->
          <div class="has-text-size-6 is-flex justify-between">

            <div class="is-flex">
              <!-- City -->
              <span aria-hidden="true" class="icon">
                        <i class="fas fa-map-marker-alt"></i>
                    </span>{{call.client.city}}

              <!-- Sex -->
              <span aria-hidden="true" class="icon ml-2">
                        <i class="fas fa-venus-mars"></i>
                    </span>{{call.client.sexName}}

              <!-- Birthday -->
              <div v-if="call.client.age">
            <span aria-hidden="true" class="icon ml-2">
                        <i class="fa fa-birthday-cake"></i>
            </span>{{call.client.age}} jaar
              </div>
            </div>

            <!-- Call status -->
            <div class="is-pulled-right">
              <div v-if="completed">
                            <span v-if="call.is_unsuccessful"
                                  class="tag is-danger">{{call.statusName}}</span>
                <span v-if="call.is_successful"
                      class="tag is-success">{{call.statusName}}</span>
              </div>
              <div v-else>
                {{ call.attempt_count}} <span v-if="!completed">eerdere
                          </span>poging<span v-if="call.attempt_count > 1">en</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="index-card-slot has-background-blue has-text-white has-text-size-14 has-text-centered is-paddingless">
        <slot></slot>
      </div>
    </a>
  </div>
</template>

<script>
  import { Call } from '../../../models/Call'
  import { Info as CallInfo } from '../containers/Call'
  import AvatarCircle from '../../../components/AvatarCircle'

  export default {
    components: {
      AvatarCircle
    },
    props: {
      call: {
        type: Call,
        required: true
      },
      completed: {
        type: Boolean,
        default: false
      },
      active: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {}
    },
    methods: {
      gotoCall (id) {
        if (this.active) {
          this.$router.push({name: CallInfo.name, params: {id}})
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar {
    width: 60px;
    height: 60px;
  }

  .index-card .index-card-content .index-card-thumbnail {
    width: 6rem;
    background-color: transparent;
  }
  .inactive {
    filter: grayscale(1);
  }

</style> 